import { Text } from '../../../../../cdl/Text/Text';
import { OfferModel } from '../../../../../offer/model/OfferModel';
import { MetaInformation } from '../../../common/OfferCard/MetaInformation';
import { getRfqOfferStatus } from '../../../components/RfqOfferCard/components/rfqOfferStatus.helpers';

interface RfqOfferStatusProps {
    offer: OfferModel;
    isClosed: boolean;
}

export const RfqOfferStatus = ({ offer, isClosed }: RfqOfferStatusProps) => {
    const { label, variant, Icon } = getRfqOfferStatus(offer, isClosed);

    return (
        <MetaInformation variant={variant}>
            <Icon width={16} height={16} />
            <Text variant="extraSmall" fontWeight={600}>
                {label}
            </Text>
        </MetaInformation>
    );
};
